import type { PersistableRightDrawerContent } from '@app/shared/types/drawer'
import { RightDrawerContent } from '@app/shared/types/drawer'

type SilverfinUserPreferences = Window['Silverfin']['currentUserPreferences']

function getPreferences(): SilverfinUserPreferences | undefined {
  return window?.Silverfin?.currentUserPreferences
}

export function readPersistedLeftCollapsed(): boolean {
  return getPreferences()?.left_drawer_collapsed ?? false
}

export function readPersistedRightContent(): PersistableRightDrawerContent {
  const prefs = getPreferences()
  const persisted = prefs?.right_drawer_content
  if (persisted === RightDrawerContent.AuditLog) {
    return RightDrawerContent.AuditLog
  }
  if (persisted === RightDrawerContent.Communication) {
    return RightDrawerContent.Communication
  }
  if (persisted !== undefined) return null

  const legacy = prefs?.open_sidepane
  if (legacy?.position === 'right') {
    const content = legacy.content as RightDrawerContent | undefined
    if (content === RightDrawerContent.AuditLog) {
      return RightDrawerContent.AuditLog
    }
    if (content === RightDrawerContent.Communication) {
      return RightDrawerContent.Communication
    }
  }
  return null
}
